import type { Custodian } from 'models/custodian';
import type { Collection } from 'state/utils/types';

export type AstroClient = {
  id?: string;
  custodians?: Custodian[];
  status?: 'pending' | 'success' | 'error' | 'not_found';
};

export type AstroClientMap = Collection<AstroClient>;

export const initialAstroClient = {};
